import { createSelector } from 'reselect';
import Polyglot from 'node-polyglot';
export var getLocale = createSelector(function (state) {
  return state.polyglot.locale;
}, function (locale) {
  return locale;
});
export var getPhrases = createSelector(function (state) {
  return state.polyglot.phrases;
}, function (phrases) {
  return phrases;
});
export var getPhrasesLoading = createSelector(function (state) {
  return state.polyglot.phrasesLoading;
}, function (phrasesLoading) {
  return phrasesLoading;
});
export var getPhrasesLoaded = createSelector(function (state) {
  return state.polyglot.phrasesLoaded;
}, function (phrasesLoaded) {
  return phrasesLoaded;
});
export var getPhrasesError = createSelector(function (state) {
  return state.polyglot.phrasesError;
}, function (phrasesError) {
  return phrasesError;
});